import { fontSize } from '@greasemap/design';

/** Props for {@link Heading}. */
export interface HeadingProps {
  readonly children: React.ReactNode;
  /**
   * Heading rank. Drives the element, and therefore the document outline that screen readers use,
   * independently of visual size.
   */
  readonly level?: 1 | 2 | 3;
  /** Visual size override, when the outline and the visual hierarchy disagree. */
  readonly size?: keyof typeof fontSize;
}

const DEFAULT_SIZE: Record<1 | 2 | 3, keyof typeof fontSize> = {
  1: '2xl',
  2: 'xl',
  3: 'lg',
};

/**
 * A section heading.
 *
 * @param props - Component props.
 * @returns The heading element.
 */
export function Heading({ children, level = 2, size }: HeadingProps): React.JSX.Element {
  const Component = `h${level}` as 'h1' | 'h2' | 'h3';

  return (
    <Component
      style={{
        fontSize: `${fontSize[size ?? DEFAULT_SIZE[level]]}px`,
        lineHeight: 1.2,
        margin: 0,
      }}
    >
      {children}
    </Component>
  );
}
